<!--
 * @Author: xing.huang
 * @Date: 2023-04-24 10:43:16
 * @LastEditTime: 2023-06-13 13:53:10
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\ERPIframe.vue
 * 
-->
<template>
    <div style="width:100%;height:99%;" v-if="isShow">
        <iframe v-for="(item,index) in urlList" :key="index" v-show="item.iframeUrl==url" :src="item.loadUrl" width="100%" height="100%" frameborder="0" scrolling="auto" ></iframe>
    </div>
</template>

<script>
// import urlConfig from '../../static/js/urlConfig.js'
export default {
    props:{
        isShow:{
            type:Boolean,
            required: false,
            default:false
        }
    },
    name: 'ERPIframe',
	data () {
        return {
            urlList:[
                {iframeUrl:'/Product/report?programid=484a7a68-f796-4cb0-b9f7-8cfd306fef76',loadUrl:''},
                {iframeUrl:'/Product/report?programid=e0225ce8-859b-451d-85d7-fed48eb29beb',loadUrl:''},
                {iframeUrl:'/Product/report?programid=8e79becb-9074-4022-b18c-2644f286092e',loadUrl:''},
                {iframeUrl:'/Product/report?programid=9b2ae6fd-9fd9-49bd-b583-df9bf59b0c3d',loadUrl:''},
                {iframeUrl:'/Product/report?programid=f2227a86-2f7a-42eb-b7f1-743e2947f6e5',loadUrl:''},
                {iframeUrl:'/Product/report?programid=0cde3afd-0147-4302-be52-ab0984d61a97',loadUrl:''},
	
                {iframeUrl:'/Product/report?programid=8ecdd780-77a5-4701-98ea-0c51d73daf64',loadUrl:''},
                {iframeUrl:'/Product/report?programid=a0d9614b-e80b-424e-81ec-4897561f958d',loadUrl:''},
                {iframeUrl:'/Product/report?programid=ef176885-1b2c-4006-b34d-7f16a8f3c160',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=668da582-ed30-65d9-abec-f620295fba42',loadUrl:''},
                {iframeUrl:'/Product/report?programid=eaec9d87-9766-4090-8f8c-2d70b1dacabe',loadUrl:''},

                {iframeUrl:'/Product/report?programid=14b6c0a0-667c-477e-960d-f3c187658713',loadUrl:''},
                {iframeUrl:'/Product/report?programid=ace526aa-857c-4e23-93c2-48f7807145e0',loadUrl:''},
                {iframeUrl:'/Product/report?programid=7c7c3679-e7b4-4c5c-9353-424ded59e6a9',loadUrl:''},
                {iframeUrl:'/Product/report?programid=3f4d4189-7be7-4562-84d5-9518fc916e6c',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=66530256-e9fe-8a91-e2f5-92e35acfff50',loadUrl:''},
                {iframeUrl:'/Product/report?programid=f3f3f1a6-827e-4e17-8fb9-42784d41b5c9',loadUrl:''},
                {iframeUrl:'/Product/report?programid=7d1ddcb6-e674-4def-b526-903d13a2553d',loadUrl:''},
                {iframeUrl:'/Product/report?programid=cdc4a7bd-cc44-46d0-a90e-81323b1f3168',loadUrl:''},
                {iframeUrl:'/Product/report?programid=461b587d-590d-4ef2-9d2a-63a77e1fc135',loadUrl:''},
                
                {iframeUrl:'/Product/report?programid=af2ddc6b-79e2-402c-973c-eb2634e7b616',loadUrl:''},
                {iframeUrl:'/Product/report?programid=b1705092-787a-4121-967b-8d40669c021b',loadUrl:''},
                {iframeUrl:'/Product/report?programid=5972b8d6-152b-493c-b665-cf2f0200ed84',loadUrl:''},

                {iframeUrl:'/Product/report?programid=aa44acc3-8210-476a-ac70-6cb72c6e1ec4',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=8b6d01b9-8192-5287-174b-87cb6478ee4b',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=8217d057-06cc-2cb2-71f0-69b162203133',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=fde9e36e-eb45-b12c-83b9-b22e43e5901a',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=636a6920-2240-4852-14ec-5800ce42a0cb',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=5762cd14-69a3-478b-be85-3c49edd37feb',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=1d669edf-e9bb-f1cb-5caf-8064cbd1ba3c',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=211dacd2-dd2f-46ee-b3b1-7bab1fde9dac',loadUrl:''},
                {iframeUrl:'/WorkFlowRun/SubTableEdit?secondtableeditform=a2767272-292d-1875-93cb-e920ed29ce2f',loadUrl:''},

                {iframeUrl:'/Product/report?programid=8b79b951-de16-42f7-8046-3b1419430621',loadUrl:''},
                {iframeUrl:'/Product/report?programid=3156a5f5-7388-4872-9c6c-411ce7f54968',loadUrl:''},
                {iframeUrl:'/Product/report?programid=c918583d-cce9-4c56-bdce-134665d4815d',loadUrl:''},
                {iframeUrl:'/Product/report?programid=cb1208d9-5c9e-468c-a2e5-84dcce4c75e3',loadUrl:''},
                {iframeUrl:urlConfig.visualUrl,loadUrl:''},
                
            ],
           url:'',
           query:{},
           erpUrl:'',
           oauthToken:'',
        }
    },
    async beforeMount  (){
        
    },
    mounted:function(){
        this.oauthToken = localStorage.getItem('oauthToken')
        this.erpUrl = localStorage.getItem('erpUrl')
        if(this.$route.query.iframeUrl){
            this.url = this.$route.query.iframeUrl
            let findIndex=this.urlList.findIndex(item=>item.iframeUrl==this.url)
            let tk = localStorage.getItem('ERPToken')||'6QZ56xxK3KxUcJmKDD-Mo03qd0-j7S7o'
            let loadUrl = ''
            if(this.$route.path.includes('/erp/iframe/888')){
                loadUrl = `${this.url}?oauthToken=${this.oauthToken}`
            }else{
                loadUrl = `${this.erpUrl}?url=${encodeURIComponent(this.url)}&tk=${tk}`
                
            }
            if(findIndex>=0){
                this.$set(this.urlList[findIndex],'loadUrl',loadUrl)
            }
        }
        
    },
    computed: {
        
        fullPath() {
            return this.$route.fullPath;
        },
    },
    methods:{
        // 获取可视化大屏token
       async getBiplantformToken(){
        let clientId = 'a141111525bac2f1edf3'
        let {data} = await this.$RequestUtil.getAsync({url: '/api/oauth2/authorize', params: {clientId},});
            //http://192.168.90.19:8899/oauth2/token
            let url = `http://192.168.90.19:8899/oauth2/authorize?response_type=code&client_id=${clientId}&state=${data.token}&redirect_uri=${data.callbackUri}&access_token=1`
            let temp = await fetch(url)
            let res = await temp.json()
            return res
        }
    },
    
    watch:{
        async fullPath(newVal,oldVal){
            if(newVal.includes('/erp/iframe')){
                if(this.$route.query.iframeUrl){
                    this.url = this.$route.query.iframeUrl
                    let findIndex=this.urlList.findIndex(item=>item.iframeUrl==this.url)
                    let tk = localStorage.getItem('ERPToken')||'6QZ56xxK3KxUcJmKDD-Mo03qd0-j7S7o'
                    let loadUrl = ''
                    if(newVal.includes('/erp/iframe/888')){
                        this.oauthToken = localStorage.getItem('oauthToken')
                        loadUrl = `${this.url}?oauthToken=${this.oauthToken}`
                    }else{
                        loadUrl = `${this.erpUrl}?url=${encodeURIComponent(this.url)}&tk=${tk}`
                        
                    }
                    if(findIndex>=0){
                        this.$set(this.urlList[findIndex],'loadUrl',loadUrl)
                    }
                }
            }
        },
    },
}
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}
.bg-purple {
    background: #d3dce6;
}

.table_searchbar{
    width:100%;
    height:100px;
    margin-top: 10px;
    margin-bottom: 20px;
}
.el-upload--picture-card{
    width:40px;
    height:40px;
}
.el-input.is-disabled .el-input__inner{
    color:#000;
}
</style>



// WEBPACK FOOTER //
// src/views/ERPIframe.vue